import customerService from "@/services/customer";
import { useQuery } from "@tanstack/react-query";

const useGetInvoiceDetail = (purchaseId?: number) =>
  useQuery({
    queryKey: ["invoice-detail", purchaseId],
    queryFn: () => customerService.getInvoiceDetail(purchaseId as number),
    enabled: typeof purchaseId === "number" && purchaseId > 0,
  });

export default useGetInvoiceDetail;
